import { getApp, getApps, initializeApp } from 'firebase/app';
import { firebaseConfig } from './firebaseConfig';

// Auth-free entry point so the messaging service worker can share the app
// without starting a second Auth instance that watches IndexedDB.
export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
